import {
  ComponentRendering,
  HtmlElementRendering,
  getChildPlaceholder,
} from "@sitecore-jss/sitecore-jss-nextjs";
import { isComponentRendering } from "./get-search-component";

const COMPONENT_NAMES = {
  PARTIAL_DESIGN: "PartialDesignDynamicPlaceholder",
  SEARCH_BAR: "Search Bar",
} as const;

const PLACEHOLDER_KEYS = {
  HEADLESS_MAIN: "headless-main",
  ASIDE: "sxa-cc-shared-aside",
} as const;

export function removeSearchComponent(
  rendering: ComponentRendering,
): (ComponentRendering | HtmlElementRendering)[] {
  const headlessMain = getChildPlaceholder(
    rendering,
    PLACEHOLDER_KEYS.HEADLESS_MAIN,
  );

  return headlessMain.map((entry) => {
    if (
      !isComponentRendering(entry) ||
      entry.componentName !== COMPONENT_NAMES.PARTIAL_DESIGN
    ) {
      return entry;
    }

    const asideComponents = getChildPlaceholder(entry, PLACEHOLDER_KEYS.ASIDE);
    const filteredAside = asideComponents.filter(
      (comp): comp is ComponentRendering =>
        isComponentRendering(comp) &&
        comp.componentName !== COMPONENT_NAMES.SEARCH_BAR,
    );

    const newPlaceholders = { ...entry.placeholders };

    if (filteredAside.length > 0) {
      newPlaceholders[PLACEHOLDER_KEYS.ASIDE] = filteredAside;
    } else {
      delete newPlaceholders[PLACEHOLDER_KEYS.ASIDE];
    }

    return {
      ...entry,
      placeholders: newPlaceholders,
    };
  });
}

export function splitAsidePlaceholder(rendering: ComponentRendering) {
  const headlessMain = getChildPlaceholder(
    rendering,
    PLACEHOLDER_KEYS.HEADLESS_MAIN,
  );

  if (!headlessMain || headlessMain.length === 0) {
    const emptyPlaceholder = { [PLACEHOLDER_KEYS.HEADLESS_MAIN]: [] };
    return {
      ...rendering,
      placeholders: { ...rendering.placeholders, ...emptyPlaceholder },
    };
  }

  return {
    ...rendering,
    placeholders: {
      ...rendering.placeholders,
      [PLACEHOLDER_KEYS.HEADLESS_MAIN]: removeSearchComponent(rendering),
    },
  };
}
